/* GIU Falò – Produktvideo-Teaser + Modal */
(function () {
  function getModal() { return document.getElementById('giu-video-modal'); }

  function openModal() {
    var modal = getModal(); if (!modal) return;
    var v = modal.querySelector('.giu-video-modal__video');
    if (v && !v.src && v.dataset.fullSrc) v.src = v.dataset.fullSrc;
    modal.hidden = false; modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('giu-modal-open');
    if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }
  function closeModal() {
    var modal = getModal(); if (!modal) return;
    var v = modal.querySelector('.giu-video-modal__video');
    if (v) v.pause();
    modal.hidden = true; modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('giu-modal-open');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-giu-open]')) { e.preventDefault(); openModal(); return; }
    if (e.target.closest('[data-giu-close]')) { closeModal(); return; }
    if (e.target.classList && e.target.classList.contains('giu-video-modal')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var m = getModal(); if (m && !m.hidden) closeModal(); }
  });

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var loop = en.target.querySelector('.giu-video-hero__loop'); if (!loop) return;
      loop.querySelectorAll('source').forEach(function (s) { if (s.dataset.src && !s.src) s.src = s.dataset.src; });
      if (!loop.dataset.loaded) { loop.load(); loop.dataset.loaded = '1'; }
      if (loop.paused) { var p = loop.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }, { threshold: 0.25 }) : null;

  // Beim Variantenwechsel: Titelbild SYNCHRON nach vorne holen (bevor der Browser zeichnet -> kein Flackern)
  function moveMainToFront() {
    var gallery = document.querySelector('media-gallery'); if (!gallery) return;
    var list = gallery.querySelector('.product__media-list'); if (!list) return;
    var slides = list.querySelectorAll('.product__media-item[data-media-id]');
    var main = null;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.mediaId.indexOf('-giu-video') === -1) { main = slides[i]; break; }
    }
    if (!main) return;
    for (var j = 0; j < slides.length; j++) slides[j].classList.remove('is-active');
    main.classList.add('is-active');
    if (list.firstElementChild !== main) list.insertBefore(main, list.firstElementChild);
    list.scrollLeft = 0;

    var thumbs = gallery.querySelector('.thumbnail-list');
    if (thumbs) {
      var mt = thumbs.querySelector('[data-target="' + main.dataset.mediaId + '"]');
      if (mt && thumbs.firstElementChild !== mt) thumbs.insertBefore(mt, thumbs.firstElementChild);
      thumbs.querySelectorAll('.thumbnail[aria-current]').forEach(function (b) { b.removeAttribute('aria-current'); });
      var mtb = mt && mt.querySelector('button'); if (mtb) mtb.setAttribute('aria-current', 'true');
    }
  }

  var firstSeen = false;
  function handleTeasers() {
    var newTeaser = false;
    document.querySelectorAll('[data-giu-video-hero]').forEach(function (n) {
      if (!n.dataset.giuObserved) { n.dataset.giuObserved = '1'; if (io) io.observe(n); newTeaser = true; }
    });
    if (newTeaser) {
      if (!firstSeen) { firstSeen = true; }   // Erstes Laden: Video bleibt vorne (zeigt beim Öffnen das Video)
      else { moveMainToFront(); }              // Variantenwechsel: Titelbild nach vorne, ohne Flackern
    }
  }
  handleTeasers();
  new MutationObserver(function () {
    handleTeasers();
    var modals = document.querySelectorAll('#giu-video-modal');
    for (var i = 0; i < modals.length - 1; i++) modals[i].remove();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
